import { useCallHistory } from '../state/TelephonyProvider'
import { useDial } from '../state/useDial'
import type { CallHistoryEntry } from '../realtime/history'
import { prettyNumber } from './_shared'
import { IconArrowDownLeft, IconArrowUpRight, IconPhoneX, IconRefresh, IconPhone, IconMail } from '../ui/icons'

const fmtDur = (s: number) => (s <= 0 ? '—' : s < 60 ? `${s}s` : `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`)
const fmtWhen = (iso: string) => {
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60_000))
  if (mins < 60) return `${mins}m ago`
  if (mins < 1440) return `${Math.round(mins / 60)}h ago`
  return `${Math.round(mins / 1440)}d ago`
}

function DirIcon({ e }: { e: CallHistoryEntry }) {
  if (e.disposition === 'missed') return <span className="sb-hist-dir dir-missed" title="missed"><IconPhoneX size={15} stroke={1.9} /></span>
  if (e.disposition === 'voicemail') return <span className="sb-hist-dir dir-missed" title="voicemail"><IconMail size={15} stroke={1.9} /></span>
  return e.direction === 'outbound'
    ? <span className="sb-hist-dir dir-out" title="outbound"><IconArrowUpRight size={15} stroke={1.9} /></span>
    : <span className="sb-hist-dir dir-in" title="inbound"><IconArrowDownLeft size={15} stroke={1.9} /></span>
}

export function CallHistoryPanel() {
  const { entries, refresh } = useCallHistory()
  const dial = useDial()

  return (
    <div className="sb-panel">
      <div className="row" style={{ marginBottom: 6 }}>
        <span className="muted" style={{ fontSize: 12 }}>Recent calls</span>
        <button className="sb-tool-btn" onClick={() => void refresh()}><IconRefresh size={13} stroke={1.75} /> refresh</button>
      </div>
      {entries === null ? (
        <div className="sb-panel-empty">Loading…</div>
      ) : entries.length === 0 ? (
        <div className="sb-panel-empty">No history yet (pull endpoint deploys with the backend).</div>
      ) : (
        entries.map((e) => (
          <div key={e.id} className="list-row row">
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
              <DirIcon e={e} />
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <strong>{e.peer_name || prettyNumber(e.peer_number) || 'Unknown'}</strong>
                <span className="faint"> · {fmtWhen(e.started_at)} · {fmtDur(e.duration_seconds)}</span>
              </span>
            </span>
            <button className="btn" title={`Call ${e.peer_number}`} aria-label={`Call ${e.peer_name || e.peer_number}`}
              onClick={() => dial(e.peer_number)}>
              <IconPhone size={14} stroke={1.75} /> call
            </button>
          </div>
        ))
      )}
    </div>
  )
}
